import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../services/authService';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await authService.login(username, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="logo-container">
          <img src="/SaiNiwasPayingGuest.png" alt="Sai Niwas Logo" className="logo-image" />
        </div>
        
        <h1>Sai Mess & Hostel</h1>
        <h2>Admin Control Panel</h2>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
              required
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
          </div>

          {error && (
            <div className="error-message">
              ⚠️ {error}
            </div>
          )}

          <button type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        
        <div className="footer-text">
          Secure Admin Access • {new Date().getFullYear()}
        </div>
      </div>

      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .login-container {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 100vh;
          background: linear-gradient(135deg, #84cc16 0%, #65a30d 100%);
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          position: relative;
          overflow: hidden;
        }

        .login-container::before {
          content: '';
          position: absolute;
          width: 400px;
          height: 400px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 50%;
          top: -100px;
          left: -100px;
          filter: blur(60px);
        }

        .login-container::after {
          content: '';
          position: absolute;
          width: 300px;
          height: 300px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 50%;
          bottom: -50px;
          right: -50px;
          filter: blur(60px);
        }

        .login-box {
          background: white;
          padding: 50px 45px 45px 45px;
          border-radius: 24px;
          box-shadow: 0 20px 60px -12px rgba(0, 0, 0, 0.3), 0 40px 80px -20px rgba(0, 0, 0, 0.2);
          width: 100%;
          max-width: 420px;
          margin: 20px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          backdrop-filter: blur(10px);
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
          z-index: 10;
          animation: slideUp 0.6s ease-out;
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .login-box:hover {
          transform: translateY(-8px);
          box-shadow: 0 30px 80px -16px rgba(0, 0, 0, 0.35), 0 50px 100px -25px rgba(0, 0, 0, 0.25);
        }

        .logo-container {
          text-align: center;
          margin-bottom: 16px;
          animation: fadeIn 0.8s ease-out 0.1s both;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        .logo-image {
          width: 120px;
          height: 120px;
          object-fit: contain;
          margin: 0 auto;
          filter: drop-shadow(0 8px 16px rgba(132, 204, 22, 0.15));
          transition: transform 0.3s ease;
        }

        .logo-image:hover {
          transform: scale(1.05);
        }

        .login-box h1 {
          text-align: center;
          font-size: 28px;
          font-weight: 700;
          color: #1f2937;
          margin-bottom: 2px;
          letter-spacing: -0.5px;
          background: linear-gradient(135deg, #84cc16 0%, #65a30d 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .login-box h2 {
          text-align: center;
          color: #6b7280;
          font-size: 15px;
          font-weight: 400;
          margin-bottom: 24px;
          letter-spacing: 0.3px;
        }

        .form-group {
          margin-bottom: 18px;
          animation: slideIn 0.6s ease-out both;
        }

        .form-group:nth-child(1) {
          animation-delay: 0.2s;
        }

        .form-group:nth-child(2) {
          animation-delay: 0.3s;
        }

        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateX(-20px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        .form-group label {
          display: block;
          margin-bottom: 10px;
          color: #374151;
          font-weight: 600;
          font-size: 14px;
          letter-spacing: 0.2px;
          text-transform: uppercase;
          opacity: 0.9;
        }

        .form-group input {
          width: 100%;
          padding: 14px 16px;
          border: 2px solid #e5e7eb;
          border-radius: 10px;
          font-size: 15px;
          box-sizing: border-box;
          background: #f9fafb;
          transition: all 0.3s ease;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }

        .form-group input:hover {
          border-color: #d1d5db;
          background: white;
        }

        .form-group input:focus {
          outline: none;
          border-color: #84cc16;
          background: white;
          box-shadow: 0 0 0 4px rgba(132, 204, 22, 0.1), inset 0 0 0 1px rgba(132, 204, 22, 0.05);
        }

        .form-group input::placeholder {
          color: #9ca3af;
          font-weight: 400;
        }

        .error-message {
          color: #dc2626;
          background: linear-gradient(135deg, #fef2f2 0%, #fecaca 100%);
          padding: 14px 16px;
          border-radius: 10px;
          margin-bottom: 24px;
          font-size: 14px;
          border: 2px solid #fca5a5;
          display: flex;
          align-items: center;
          gap: 10px;
          animation: shake 0.4s ease-out;
        }

        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-8px); }
          75% { transform: translateX(8px); }
        }

        button[type="submit"] {
          width: 100%;
          padding: 14px 16px;
          background: linear-gradient(135deg, #84cc16 0%, #65a30d 100%);
          color: white;
          border: none;
          border-radius: 10px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          letter-spacing: 0.3px;
          margin-top: 8px;
          box-shadow: 0 8px 16px -4px rgba(132, 204, 22, 0.3);
          animation: slideIn 0.6s ease-out 0.4s both;
        }

        button[type="submit"]:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 12px 24px -6px rgba(132, 204, 22, 0.4);
        }

        button[type="submit"]:active:not(:disabled) {
          transform: translateY(0);
        }

        button[type="submit"]:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        .footer-text {
          text-align: center;
          margin-top: 20px;
          font-size: 13px;
          color: #9ca3af;
          letter-spacing: 0.2px;
          animation: fadeIn 0.8s ease-out 0.5s both;
        }
      `}</style>
    </div>
  );
};

export default LoginPage;
